/**
 * Minimalerei Mobile-Menu — Dawn-Drawer-Override für SHOP-Editorial
 *
 * Dawn's MenuDrawer bindet onSummaryClick an alle <summary> im Drawer
 * und fügt beim Click 'submenu-open' zum Eltern-<ul class="has-submenu">.
 * Das versteckt unser Editorial via visibility:hidden.
 *
 * Lösung: Wir KLONEN unsere SHOP- und Sub-Accordion-Summaries.
 * Klonen entfernt alle bestehenden Event-Listener (inkl. Dawn's).
 * Dann attachen wir unsere eigene Toggle-Logik direkt.
 *
 * Damit gibt's keine Race-Condition mit Dawn und kein
 * stopImmediatePropagation-Workaround mehr nötig.
 */

(function () {
  'use strict';

  function replaceSummaryWithCleanClone(summary) {
    if (!summary) return null;
    const clone = summary.cloneNode(true);
    summary.parentNode.replaceChild(clone, summary);
    return clone;
  }

  function attachManualToggle(summary, details) {
    if (!summary || !details) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
      // Falls Dawn-Klassen trotzdem reinrutschen: cleanup.
      details.classList.remove('menu-opening');
      const parentUl = details.closest('.has-submenu');
      if (parentUl) parentUl.classList.remove('submenu-open');
    });
  }

  function initMobileShop() {
    const shopDetails = document.querySelectorAll('[data-mp-mobile-shop]');

    shopDetails.forEach(function (details) {
      // SHOP-Summary klonen + manuellen Toggle attachen
      const originalSummary = details.querySelector(':scope > summary');
      const cleanSummary = replaceSummaryWithCleanClone(originalSummary);
      attachManualToggle(cleanSummary, details);

      // Sub-Accordions (Schnellzugriff, Story) genauso behandeln
      const subDetails = details.querySelectorAll('[data-mp-mobile-sub]');
      subDetails.forEach(function (sub) {
        const originalSubSummary = sub.querySelector(':scope > summary');
        const cleanSubSummary = replaceSummaryWithCleanClone(originalSubSummary);
        attachManualToggle(cleanSubSummary, sub);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileShop);
  } else {
    initMobileShop();
  }
})();
